var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.breakpoint=='xs')?_c('IndexCompact',{attrs:{"farmers":_vm.farmers}}):(_vm.partnerCode && _vm.breakpoint !== 'xs')?_c('IndexNormalNile',{attrs:{"farmers":_vm.farmers}}):_c('IndexNormal',{attrs:{"farmers":_vm.farmers}})}
var staticRenderFns = []

export { render, staticRenderFns }